export default "__VITE_ASSET__lRI2YD____"